import _regeneratorRuntime from "/root/app/node_modules/@babel/runtime/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(audienceSaveListener),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(redirectToAudiencesPageSaga),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(audienceSaveSaga),
    _marked4 = /*#__PURE__*/_regeneratorRuntime.mark(audienceSegmentsListener),
    _marked5 = /*#__PURE__*/_regeneratorRuntime.mark(audienceSegmentsSaga),
    _marked6 = /*#__PURE__*/_regeneratorRuntime.mark(audiencesListener),
    _marked7 = /*#__PURE__*/_regeneratorRuntime.mark(audiencesSaga),
    _marked8 = /*#__PURE__*/_regeneratorRuntime.mark(audienceDetailsListener),
    _marked9 = /*#__PURE__*/_regeneratorRuntime.mark(audienceDetailsSaga),
    _marked10 = /*#__PURE__*/_regeneratorRuntime.mark(audiencesDeleteSaga);

import { put, takeLatest, select } from 'redux-saga/effects';
import createRequestSaga from '@signal/utils/createRequestSaga';
import { push } from 'connected-react-router';
import { audiencesPathSelector } from './../router';
import api from '../api';
import { withAudienceMicroserviceUrl } from '../api/utils';
import { audiencesLoad, audiencesDeleteLoad, audiencesDeleteSuccess, audiencesActions, audiencesDeleteActions, audienceSegmentsLoad, audienceSegmentsActions, audienceDetailsLoad, audienceDetailsActions, audienceSaveActions, audienceSaveLoad } from './actions';
import { audienceListLoadedSelector, audienceListLoadingSelector } from './selectors';
import { activeAccountIdSelector } from '../auth';
/**
 * Audience Save
 */

/**
 * Audience save request saga.
 * @type {createRequestSaga~requestSaga}
 */

export var saveAudience = createRequestSaga(audienceSaveActions); //, {
//   loadedSelector: usersLoadedSelector
// })
// TODO: add the loading and loaded selectors

/**
 * Audience segments listener saga.
 * @return {Generator}
 */

export function audienceSaveListener() {
  return _regeneratorRuntime.wrap(function audienceSaveListener$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return takeLatest(audienceSaveLoad.getType(), audienceSaveSaga);

        case 2:
          _context.next = 4;
          return takeLatest(audienceSaveActions.success.getType(), redirectToAudiencesPageSaga);

        case 4:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
export function redirectToAudiencesPageSaga() {
  var path;
  return _regeneratorRuntime.wrap(function redirectToAudiencesPageSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return select(audiencesPathSelector);

        case 2:
          path = _context2.sent;
          _context2.next = 5;
          return put(push(path));

        case 5:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}
/**
 * Audience segments saga. Fetches audience segments from the API and dispatches either success or
 * failure depending on the result.
 * @return {Generator}
 */

export function audienceSaveSaga(_ref) {
  var audience, activeAccountId;
  return _regeneratorRuntime.wrap(function audienceSaveSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          audience = _ref.payload.audience;
          _context3.next = 3;
          return select(activeAccountIdSelector);

        case 3:
          activeAccountId = _context3.sent;
          _context3.next = 6;
          return put(api.post(audienceSaveActions, withAudienceMicroserviceUrl("/configs/".concat(activeAccountId)), {
            body: audience
          }));

        case 6:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}
/**
 * Audience Segments
 */

/**
 * Audience segments request saga.
 * @type {createRequestSaga~requestSaga}
 */

export var loadAudienceSegments = createRequestSaga(audienceSegmentsActions); //, {
//   loadedSelector: usersLoadedSelector
// })
// TODO: add the loading and loaded selectors

/**
 * Audience segments listener saga.
 * @return {Generator}
 */

export function audienceSegmentsListener() {
  return _regeneratorRuntime.wrap(function audienceSegmentsListener$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return takeLatest(audienceSegmentsLoad.getType(), audienceSegmentsSaga);

        case 2:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}
/**
 * Audience segments saga. Fetches audience segments from the API and dispatches either success or
 * failure depending on the result.
 * @return {Generator}
 */

export function audienceSegmentsSaga(_ref2) {
  var _ref2$payload, payload, id, target, activeAccountId;

  return _regeneratorRuntime.wrap(function audienceSegmentsSaga$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _ref2$payload = _ref2.payload, payload = _ref2$payload === void 0 ? {} : _ref2$payload;
          id = payload.id, target = payload.audience.target;
          _context5.next = 4;
          return select(activeAccountIdSelector);

        case 4:
          activeAccountId = _context5.sent;
          _context5.next = 7;
          return put(api.post(audienceSegmentsActions, withAudienceMicroserviceUrl("/configs/".concat(activeAccountId, "/segments")), {
            body: target || {}
          }, {
            request: function request() {
              return {
                id: id
              };
            },
            success: function success(data) {
              return {
                data: data,
                id: id
              };
            },
            failure: function failure(error) {
              return {
                error: error,
                id: id
              };
            }
          }));

        case 7:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}
/**
 * Audiences
 */

/**
 * Audiences request saga.
 * @type {createRequestSaga~requestSaga}
 */

export var loadAudiences = createRequestSaga(audiencesActions, {
  loadedSelector: audienceListLoadedSelector,
  loadingSelector: audienceListLoadingSelector
});
/**
 * Audiences listener saga.
 * @return {Generator}
 */

export function audiencesListener() {
  return _regeneratorRuntime.wrap(function audiencesListener$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return takeLatest(audiencesLoad.getType(), audiencesSaga);

        case 2:
          _context7.next = 4;
          return takeLatest(audiencesDeleteLoad.getType(), audiencesDeleteSaga);

        case 4:
          _context7.next = 6;
          return takeLatest(audiencesDeleteSuccess.getType(), /*#__PURE__*/_regeneratorRuntime.mark(function deleteAudienceSuccessSaga() {
            return _regeneratorRuntime.wrap(function deleteAudienceSuccessSaga$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    _context6.next = 2;
                    return put(audiencesLoad());

                  case 2:
                  case "end":
                    return _context6.stop();
                }
              }
            }, deleteAudienceSuccessSaga);
          }));

        case 6:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked6);
}
/**
 * Audiences saga. Fetches audiences from the API and dispatches either success or
 * failure depending on the result.
 * @return {Generator}
 */

export function audiencesSaga() {
  var activeAccountId;
  return _regeneratorRuntime.wrap(function audiencesSaga$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return select(activeAccountIdSelector);

        case 2:
          activeAccountId = _context8.sent;
          _context8.next = 5;
          return put(api.get(audiencesActions, withAudienceMicroserviceUrl("/configs/".concat(activeAccountId))));

        case 5:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked7);
}
/**
 * Audience Detail
 */

/**
 * Audience details request saga.
 * @type {createRequestSaga~requestSaga}
 */

export var loadAudienceDetails = createRequestSaga(audienceDetailsActions); //, {
//   loadedSelector: usersLoadedSelector
// })

/**
 * Audience details listener saga.
 * @return {Generator}
 */

export function audienceDetailsListener() {
  return _regeneratorRuntime.wrap(function audienceDetailsListener$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return takeLatest(audienceDetailsLoad.getType(), audienceDetailsSaga);

        case 2:
          _context9.next = 4;
          return takeLatest(audienceSaveLoad.getType(), audienceSaveSaga);

        case 4:
          _context9.next = 6;
          return takeLatest(audienceSaveActions.success.getType(), redirectToAudiencesPageSaga);

        case 6:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked8);
}
/**
 * Audiences saga. Fetches audiences from the API and dispatches either success or
 * failure depending on the result.
 * @return {Generator}
 */

export function audienceDetailsSaga(_ref3) {
  var payload, id, activeAccountId;
  return _regeneratorRuntime.wrap(function audienceDetailsSaga$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          payload = _ref3.payload;
          id = payload.id;

          if (id) {
            _context10.next = 6;
            break;
          }

          _context10.next = 5;
          return put(audienceDetailsActions.success({}));

        case 5:
          return _context10.abrupt("return", _context10.sent);

        case 6:
          _context10.next = 8;
          return select(activeAccountIdSelector);

        case 8:
          activeAccountId = _context10.sent;
          _context10.next = 11;
          return put(api.get(audienceDetailsActions, withAudienceMicroserviceUrl("/configs/".concat(activeAccountId, "/").concat(id)), null, {
            request: function request() {
              return id;
            }
          }));

        case 11:
        case "end":
          return _context10.stop();
      }
    }
  }, _marked9);
}
/**
 * Audiences saga. Deletes the given audience from the API and dispatches either
 * success or failure depending on the result.
 * @return {Generator}
 */

export function audiencesDeleteSaga(_ref4) {
  var payload, activeAccountId;
  return _regeneratorRuntime.wrap(function audiencesDeleteSaga$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          payload = _ref4.payload;
          _context11.next = 3;
          return select(activeAccountIdSelector);

        case 3:
          activeAccountId = _context11.sent;
          _context11.next = 6;
          return put(api.delete(audiencesDeleteActions, withAudienceMicroserviceUrl("/configs/".concat(activeAccountId, "/").concat(payload))));

        case 6:
        case "end":
          return _context11.stop();
      }
    }
  }, _marked10);
}